import { SECTIONS } from './questions.js';
import { syncPaymentForm } from '../src/payment/PaymentForm.js';

const screenIds = ['screenSample', 'screenPay', 'appWorkspace', 'screenReview', 'screenDone', 'dashboardContainer'];

function showOnly(elements, activeId) {
  screenIds.forEach((id) => {
    if (elements[id]) {
      elements[id].style.display = id === activeId ? '' : 'none';
    }
  });
}

function setWizardReadOnly(elements, isReadOnly) {
  const form = elements.handbookForm;
  if (!form) return;
  form.querySelectorAll('input, textarea, button, select').forEach((node) => {
    if (node.id === 'btn-wizard-back' || node.id === 'btn-wizard-next') {
      node.disabled = isReadOnly;
      return;
    }
    node.disabled = isReadOnly;
  });
}

function deriveScreen(state) {
  if (!state.user) return 'sample';
  if (!state.childId || !state.productId || state.screenIntent === 'dashboard') return 'dashboard';
  const status = state.entitlement?.status ?? 'none';
  if (state.screenIntent === 'pay') return 'pay';
  if (status === 'fulfilled') return state.screenIntent === 'wizard' ? 'wizard' : 'done';
  if (status === 'paid') {
    if (state.screenIntent === 'review' || (state.questionnaireComplete && state.currentStep >= SECTIONS.length)) {
      return 'review';
    }
    return 'wizard';
  }
  if (status === 'pending' || status === 'none' || status === 'failed') return 'pay';
  return 'sample';
}

export function routeScreen(ctx) {
  const screen = deriveScreen(ctx.state);
  ctx.state.activeScreen = screen;
  ctx.elements.mobileTabs.style.display = screen === 'wizard' ? '' : 'none';
  ctx.elements.btnPreviewPrint.style.display = screen === 'wizard' ? 'inline-flex' : 'none';
  setWizardReadOnly(ctx.elements, screen === 'done');
  syncPaymentForm({
    childId: ctx.state.childId,
    productId: ctx.state.productId,
    shouldShow: screen === 'pay',
  });

  if (screen === 'sample') {
    showOnly(ctx.elements, 'screenSample');
    return screen;
  }
  if (screen === 'pay') {
    showOnly(ctx.elements, 'screenPay');
    return screen;
  }
  if (screen === 'dashboard') {
    showOnly(ctx.elements, 'dashboardContainer');
    ctx.renderDashboard();
    return screen;
  }
  if (screen === 'wizard') {
    if (ctx.state.currentStep >= SECTIONS.length) ctx.state.currentStep = SECTIONS.length - 1;
    showOnly(ctx.elements, 'appWorkspace');
    ctx.updateWizardUI();
    ctx.updatePreview();
    return screen;
  }
  if (screen === 'review') {
    showOnly(ctx.elements, 'screenReview');
    ctx.renderReviewScreen('review');
    return screen;
  }
  showOnly(ctx.elements, 'screenDone');
  ctx.renderReviewScreen('done');
  return screen;
}
